import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-grid-line text-base" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                {t("brandName")}
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">{t("footerTagline")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              {t("footerNavTitle")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">
                  {t("navHome")}
                </Link>
              </li>
              <li>
                <Link to="/#guides" className="text-sm text-background-300 hover:text-background-50 transition-colors">
                  {t("navShoppingGuide")}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-sm text-background-300 hover:text-background-50 transition-colors">
                  {t("navCategories")}
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-background-300 hover:text-background-50 transition-colors">
                  {t("navFaq")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              {t("footerCategoriesTitle")}
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              {t("footerLegalTitle")}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">
                  {t("ctaBasetao")}
                </a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">
                  {t("ctaBuyNow")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800">
          <p className="text-xs text-background-400 leading-relaxed max-w-4xl">
            {t("footerDisclaimerText")}
          </p>
          <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
            <p className="text-xs text-background-400">
              © {new Date().getFullYear()} {t("brandName")}. {t("footerCopyright")}
            </p>
            <p className="text-xs text-background-400">{t("footerMadeWith")}</p>
          </div>
        </div>
      </div>
    </footer>
  );
}